<template>
  <el-container style="height: 100%">
    <!-- <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: 100%">
      <Aside></Aside>
    </el-aside> -->

    <el-container style="height: 100%; overflow: hidden">
      <el-header style="text-align: right; font-size: 12px; height: 100%">
        <Header> </Header>
      </el-header>

      <el-main
        :class="{
          'active-margin-top': isMarginTopRequire,
          'question-bg': isBGRequire,
        }"
        style="
          height: 100%;
          padding: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          /* margin-top: 30px; */
          overflow: hidden;
        "
      >
        <!-- <Main></Main> -->
        <router-view v-if="isRouterAlive"></router-view>
        <el-footer
          v-if="isMain"
          style="
            height: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
          "
        >
          <div class="footer-text">
            <span class="linkClass">
              <a
                href="http://101.201.209.30/img/file/phak.pdf"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >《PHAK》电子书&emsp;</a
              >|
              <a
                href="http://101.201.209.30/img/file/cidian.pdf"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >&emsp;飞行员中英词典&emsp;</a
              >|
              <a
                href="http://101.201.209.30/img/file/G1000.pdf"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >&emsp;G1000说明书&emsp;</a
              >|
              <a
                href="http://101.201.209.30/img/file/POH.pdf"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >&emsp;C-172S《POH》&emsp;</a
              >|
              <a
                href="http://101.201.209.30/img/file/jepp.pdf"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >&emsp;jepp航图解析&emsp;</a
              >|
              <a
                href="http://101.201.209.30/img/file/c172cockpit.jpg"
                style="color: #dedede; text-decoration: none"
                target="_blank"
                >&emsp;C-172S座舱图&emsp;</a
              >
            </span>
          </div>
          <div>
            <p class="footer-introduction">
              《地面理论与航空系统工程》题库管理系统&emsp; Copyright © 2024
              邓向杰.All Rights Reserved.
            </p>
          </div>
        </el-footer>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Aside from "../components/Aside.vue";
import Header from "../components/Header.vue";
import Main from "../components/Main.vue";
import MyHome from "./home/MyHome.vue";

export default {
  components: { Aside, Header, Main },
  name: "Index",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },

  computed: {
    isMain() {
      return this.$route.fullPath == "/main";
    },
    isBGRequire() {
      if (
        this.$route.fullPath == "/question/insert" ||
        this.$route.fullPath == "/question/edit/detail" 
        
      ) {
        return true;
      }
    },
    isMarginTopRequire() {
      if (this.$route.fullPath != "/sequential/exercise/view") {
      } else {
        return false;
      }

      if (this.$route.fullPath != "/login") {
      } else {
        return false;
      }

      if (this.$route.fullPath != "/question/insert") {
      } else {
        return false;
      }

      if (this.$route.fullPath != "/question/edit/detail") {
      } else {
        return false;
      }
      return true;
    },
  },
  mounted() {
    // console.log(this.$route.fullPath)
  },
};
</script>

<style scope lang="scss">
.active-margin-top {
  margin-top: 30px;
}
.question-bg {
  background-color: #eeeeee;
}
.el-footer {
  background-color: #2c2e32;
  color: #333;
  text-align: center;
  // line-height: 150px;
  width: 100%;
  margin-top: 90px;

  .footer-text {
    display: flex;
    flex-direction: column;
    color: #bebebe;
    text-align: center;
    box-sizing: border-box;

    //这里a标签样式没生效？
    .a {
      margin-bottom: 0.5em;
      color: #ffffff;
      box-sizing: border-box;
      &:hover {
        text-decoration: dashed;
      }
    }
  }
  .footer-introduction {
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #dedede;
    font-size: 14px;
    font-family: 黑体;
  }
}

.el-header {
  background-color: #ffffff;
  color: #ffffff;
  line-height: 60px;
  border-bottom: 1px solid #dadada;
}

.el-aside {
  color: #333;
}

// .el-main::deep{
//   overflow: hidden;
// }
</style>
